(() => {
  const revealSelector = [
    '.story-origins__content',
    '.story-origins__media',
    '.ingredients-header',
    '.ingredient-card',
    '.collection-row-1__container',
    '.collection-card',
    '.collection-row-3',
    '.mosaic-left__content',
    '.mosaic-right',
    '.waitlist-container',
    '.enquiries-container',
    '.about-hero__inner',
    '.beginning__content',
    '.beginning__media',
    '.founder__media',
    '.founder__content',
    '.closing__inner',
    '.ing__media',
    '.ing__content',
    '.col__header',
    '.col__card',
    '.sc__card',
    '.wl__left-inner',
    '.wl__right-inner',
    '.product__media-wrapper',
    '.product__info-wrapper',
    '.cart-items',
    '.cart__footer',
    '.footer-container',
    '.footer-bottom'
  ].join(',');

  const parallaxSelector = [
    '.ingredient-card__img-container img',
    '.story-origins__img-wrap img',
    '.story-manifesto__img-wrap img',
    '.collection-card__bg img',
    '.collection-row-2__center-box img',
    '.collection-row-3__bg img'
  ].join(',');

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let parallaxEls = [];
  let rafPending = false;

  function revealVariant(el) {
    if (el.matches('.story-origins__content, .mosaic-left__content, .beginning__content, .founder__content, .product__info-wrapper, .ing__content, .wl__left-inner, .col__header, .footer-container, .footer-bottom')) {
      return 'left';
    }
    if (el.matches('.story-origins__media, .beginning__media, .founder__media, .product__media-wrapper, .ing__media, .mosaic-right, .wl__right-inner')) {
      return 'right';
    }
    if (el.matches('.ingredient-card, .collection-card, .collection-row-3, .col__card, .sc__card')) {
      return 'lift';
    }
    return 'soft';
  }

  function staggerDelay(el) {
    const staggerGroups = [
      '.ingredients-grid .ingredient-card',
      '.collection-grid .collection-card',
      '.shop-collection-grid .sc__card',
      '.footer-socials .footer-socials__link'
    ];

    for (const selector of staggerGroups) {
      if (el.matches(selector)) {
        const siblings = [...el.parentElement.querySelectorAll(selector)];
        const index = siblings.indexOf(el);
        return Math.min(index * 0.08, 0.24);
      }
    }

    return 0;
  }

  function initReveal(root = document) {
    const els = [...root.querySelectorAll(revealSelector)].filter((el) => !el.dataset.elReveal);
    els.forEach((el) => {
      el.dataset.elReveal = '1';
      el.classList.add('el-reveal', `el-reveal--${revealVariant(el)}`);
      const delay = staggerDelay(el);
      if (delay) el.style.setProperty('--el-delay', `${delay}s`);
    });

    if (!('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        }),
      { threshold: 0.1, rootMargin: '0px 0px -8% 0px' }
    );

    els.forEach((el) => io.observe(el));
  }

  function refreshParallax() {
    parallaxEls = [...document.querySelectorAll(parallaxSelector)];
    updateParallax();
  }

  function updateParallax() {
    if (prefersReducedMotion || !parallaxEls.length) {
      rafPending = false;
      return;
    }

    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    parallaxEls.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.bottom < -80 || rect.top > viewportHeight + 80) return;

      const centerOffset = rect.top + rect.height / 2 - viewportHeight / 2;
      const normalized = centerOffset / (viewportHeight / 2);
      const translate = Math.max(-8, Math.min(8, normalized * -5.5));
      el.style.setProperty('--el-parallax-y', `${translate.toFixed(2)}px`);
    });

    rafPending = false;
  }

  function requestParallax() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(updateParallax);
  }

  function setup() {
    initReveal();
    refreshParallax();

    if (!prefersReducedMotion) {
      window.addEventListener('scroll', requestParallax, { passive: true });
      window.addEventListener('resize', requestParallax);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initReveal(event.target);
    refreshParallax();
  });
})();
